<section class="rs-es-first-section">
  <mprd-back-link></mprd-back-link>
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-tit1-sp rs-txt-c2">
        {{ "sim.transfer-esim" | translate }}
      </h1>
      <div class="rs-panel-big rs-bg-c2 clearfix">
        <h2 id="ac-steps-title">
          {{ "sim.transfer-esim.subtitle" | translate }}
        </h2>
        <div [innerHTML]="'sim.transfer-esim.header' | translate"></div>
        <div class="panel rs-bg-grey2">
          <div class="rs-tmline" aria-labelledby="ac-steps-title">
            <ol class="rs-tmline-list">
              <li class="rs-tmline-item rs-selected">
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step 1 of 4"></span>
                    <span aria-hidden="true">1</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{ "sim.transfer-esim.step-1-title" | translate }}
                </div>
                <div
                  class="rs-tmline-content"
                  [innerHTML]="'sim.transfer-esim.step-1-content' | translate"
                ></div>
              </li>
              <li class="rs-tmline-item rs-selected">
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step 2 of 4"></span>
                    <span aria-hidden="true">2</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{ "sim.transfer-esim.step-2-title" | translate }}
                </div>
                <div
                  class="rs-tmline-content"
                  [innerHTML]="'sim.transfer-esim.step-2-content' | translate"
                ></div>
              </li>
              <li class="rs-tmline-item rs-selected">
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step 3 of 4"></span>
                    <span aria-hidden="true">3</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{ "sim.transfer-esim.step-3-title" | translate }}
                </div>
                <div class="rs-tmline-content">
                  <div
                    [innerHTML]="
                      'sim.transfer-esim.step-3-content' | translate
                    "
                  ></div>
                  <div class="rs-flex-row rs-flex-dir-col-small-only">
                    <div class="rs-flex-column rs-order-m2">
                      <button
                        class="rs-btn rs-btn-second jsrs-toaster rs-btn-nl-so rs-no-margin-m"
                        (click)="showAndroidToaster = true"
                      >
                        {{ "sim.transfer-esim.via-android" | translate }}
                      </button>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink rs-order-m1">
                      <button
                        class="rs-btn rs-btn-second jsrs-toaster rs-btn-nl-m rs-no-margin"
                        (click)="showIosToaster = true"
                      >
                        {{ "sim.transfer-esim.via-ios" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              <li class="rs-tmline-item rs-selected">
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step 4 of 4"></span>
                    <span aria-hidden="true">4</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{ "sim.transfer-esim.step-4-title" | translate }}
                </div>
                <div class="rs-tmline-content">
                  <div
                    [innerHTML]="
                      'sim.transfer-esim.step-4-content' | translate
                    "
                  ></div>
                  <button class="rs-btn" (click)="showQrCode = true">
                    {{ "sim.transfer-esim.display-qr" | translate }}
                  </button>
                </div>
              </li>
            </ol>
          </div>
        </div>
        <a
          [href]="'sim.transfer-esim.assistance-url' | translate"
          class="rs-btn rs-btn-third"
        >
          {{ "sim.transfer-esim.assistance" | translate }}
          <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"> </i
        ></a>
        <mprd-generic-toaster
          id="android-toaster"
          [title]="'sim.transfer-esim.via-android' | translate"
          [open]="showAndroidToaster"
          (close)="showAndroidToaster = false"
        >
          <div class="rs-tmline" aria-labelledby="android-toaster-title">
            <ol class="rs-tmline-list">
              <li
                *ngFor="let i of [1, 2, 3, 4, 5]"
                class="rs-tmline-item rs-selected"
              >
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step {{ i }} of 5"></span>
                    <span aria-hidden="true">{{ i }}</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{
                    "sim.transfer-esim.via-android.step-" + i + "-title"
                      | translate
                  }}
                </div>
                <div
                  class="rs-tmline-content"
                  [innerHTML]="
                    'sim.transfer-esim.via-android.step-' + i + '-content'
                      | translate
                  "
                ></div>
              </li>
            </ol>
            <div class="rs-me"></div>
            <div [innerHTML]="'sim.transfer-esim.done' | translate"></div>
          </div>
        </mprd-generic-toaster>
        <mprd-generic-toaster
          id="ios-toaster"
          [title]="'sim.transfer-esim.via-ios' | translate"
          [open]="showIosToaster"
          (close)="showIosToaster = false"
        >
          <div class="rs-tmline" aria-labelledby="ios-toaster-title">
            <ol class="rs-tmline-list">
              <li
                *ngFor="let i of [1, 2, 3, 4, 5]"
                class="rs-tmline-item rs-selected"
              >
                <div class="rs-tmline-indicator">
                  <div class="rs-tmline-indicator-el">
                    <span aria-label="Step {{ i }} of 5"></span>
                    <span aria-hidden="true">{{ i }}</span>
                  </div>
                </div>
                <div class="rs-tmline-title">
                  {{
                    "sim.transfer-esim.via-ios.step-" + i + "-title"
                      | translate
                  }}
                </div>
                <div
                  class="rs-tmline-content"
                  [innerHTML]="
                    'sim.transfer-esim.via-ios.step-' + i + '-content'
                      | translate
                  "
                ></div>
              </li>
            </ol>
            <div class="rs-me"></div>
            <div [innerHTML]="'sim.transfer-esim.done' | translate"></div>
          </div>
        </mprd-generic-toaster>
        <lib-overlayer
          popUpID="qr-modal"
          [displaySubTitle]="false"
          [displayFooter]="false"
          [options]="{ backDrop: true, closeViaBackdrop: true }"
          [showModal]="showQrCode"
          (onClose)="showQrCode = false"
        >
          <ng-container Title>
            {{ "sim.transfer-esim.scan-qr" | translate }}
          </ng-container>
          <ng-container Content>
            <div
              [innerHTML]="'sim.transfer-esim.scan-qr-help' | translate"
            ></div>
            <div class="text-center">
              <qrcode
                [qrdata]="activationCode$ | async"
                [allowEmptyString]="true"
                [width]="150"
              ></qrcode>
            </div>
          </ng-container>
        </lib-overlayer>
      </div>
      <div class="rs-le2"></div>
    </div>
  </div>
</section>
